<template>
    <section class="admin-content" id="contact-search">
        <Navbar />
        <main class="admin-main">
            <div>
                <div class="bg-info m-b-30">
                    <div class="container">
                        <div class="row p-b-60 p-t-60">
                            <div class="col-md-6 text-center mx-auto text-white p-b-30">
                                <div class="m-b-10">
                                    <div class="avatar"></div>
                                </div>
                                <h3 class="h5">{{ organization.name }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="pull-up">
                    <div class="container">
                        <div class="row list">
                            <div class="col-lg-12 col-md-12">
                                <div class="card m-b-30">
                                    <div class="card-header"></div>

                                    <div class="card-body">
                                        <div class="form-group">
                                            <button class="btn btn-outline-info" @click="acceptorganization(1)"
                                                v-if="organization.status == false">
                                                Approve
                                            </button>
                                            <button class="btn btn-outline-danger" @click="acceptorganization(0)"
                                                v-if="organization.status == true">
                                                Disapprove
                                            </button>
                                            <router-link :to="{ path: '/add-employee-state'}">
                                                <button class="btn btn-outline-info spacer">
                                                    Manage Personnel
                                                </button>
                                            </router-link>

                                            <button class="btn btn-outline-info m-2" data-toggle="modal"
                                                data-target="#slideRightModalAll">
                                                Add Payment
                                            </button>

                                            <button class="btn btn-outline-warning m-2" data-toggle="modal"
                                                data-target="#certificateModal">
                                                <i class="fe fe-award"></i> Generate Certificate
                                            </button>

                                            <button class="btn btn-outline-info m-2" @click="triggerCsvImport">
                                                Import Enrollees
                                            </button>
                                            <button class="btn btn-outline-info m-2" @click="downloadSampleCsv">
                                                Download Sample Sheet
                                            </button>
                                            <input ref="csvInput" type="file" accept=".csv,text/csv" class="d-none"
                                                @change="onCsvFileSelected" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-3 col-md-3">
                                <div class="card m-b-30">
                                    <div class="card-body">
                                        <div class="pb-2">
                                            <router-link :to="{ path: '/view-clients-agency' }">
                                                <div class="avatar avatar-lg">
                                                    <div class="avatar-title bg-soft-info rounded-circle">
                                                        <i class="mdi mdi-account-group"></i>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </div>
                                        <div>
                                            <p class="text-muted text-overline m-0">
                                                Total Enrollees
                                            </p>
                                            <h1 class="fw-400">
                                                {{ dashboarddata.enrollees | numeral("0,0") }}
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-3">
                                <div class="card m-b-30">
                                    <div class="card-body">
                                        <div class="pb-2">
                                            <div class="avatar avatar-lg">
                                                <div class="avatar-title bg-soft-info rounded-circle">
                                                    <i class="mdi mdi-folder-multiple"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <p class="text-muted text-overline m-0">Encounters</p>
                                            <h1 class="fw-400">
                                                {{ dashboarddata.encounters | numeral("0,0") }}
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-3">
                                <div class="card m-b-30">
                                    <div class="card-body">
                                        <div class="pb-2">
                                            <router-link :to="{ path: '/all-claims' }">
                                                <div class="avatar avatar-lg">
                                                    <div class="avatar-title bg-soft-info rounded-circle">
                                                        <i class="fe fe-credit-card"></i>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </div>
                                        <div>
                                            <p class="text-muted text-overline m-0">Transactions</p>
                                            <h1 class="fw-400">
                                                {{ transactions.total
                                                | numeral("0,0") }}
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="col-lg-3 col-md-3">
                                <div class="card m-b-30">
                                    <div class="card-body">
                                        <div class="pb-2">
                                            <div class="avatar avatar-lg">
                                                <div class="avatar-title bg-soft-info rounded-circle">
                                                    <i class="mdi mdi-folder-multiple"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <p class="text-muted text-overline m-0">
                                                Total Utilization Rate
                                            </p>
                                            <h1 class="fw-400">
                                                {{
                                                dashboarddata.encounter_rate_total
                                                | numeral("0,0.00")
                                                }}%
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div class="col-lg-3 col-md-3">
                                <div class="card m-b-30">
                                    <div class="card-body">
                                        <div class="pb-2">
                                            <div class="avatar avatar-lg">
                                                <div class="avatar-title bg-soft-info rounded-circle">
                                                    <i class="mdi mdi-folder-multiple"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <p class="text-muted text-overline m-0">
                                                Utilization Rate (Current Month)
                                            </p>
                                            <h1 class="fw-400">
                                                {{
                                                dashboarddata.encounter_rate_current_month
                                                | numeral("0,0.00")
                                                }}%
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-3">
                                <div class="card m-b-30">
                                    <div class="card-body">
                                        <div class="pb-2">
                                            <div class="avatar avatar-lg">
                                                <div class="avatar-title bg-soft-info rounded-circle">
                                                    <i class="mdi mdi-bank-transfer-out"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <p class="text-muted text-overline m-0">
                                                Referral Rate (Current Month)
                                            </p>
                                            <h1 class="fw-400">
                                                {{
                                                dashboarddata.referral_rate_current_month
                                                | numeral("0,0.00")
                                                }}%
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="card m-b-30">
                                    <div class="card-header">
                                        <h4 class="h4"> Enrollees</h4>
                                    </div>

                                    <div class="card-body">
                                        <div class="table-responsive">
                                            <table class="table align-td-middle table-card">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>ID</th>
                                                        <th>Contact</th>
                                                        <th>Plan</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="enrollee in organizationclients.data"
                                                        v-bind:key="enrollee.id">
                                                        <td>
                                                            <router-link :to="{ path: '/client/' + enrollee.id }">
                                                                {{ enrollee.full_name }} </router-link>
                                                        </td>
                                                        <td>{{ enrollee.id_card_number }}</td>
                                                        <td>{{ enrollee.phone_number }}</td>
                                                        <td>{{ enrollee.sector }}</td>

                                                        <td>
                                                            <router-link :to="{ path: '/client/' + enrollee.id }">
                                                                <button type="button" name="button"
                                                                    class="btn btn-outline-info">
                                                                    <i class="fe fe-eye"></i>
                                                                </button>
                                                            </router-link>

                                                            <!-- <button class="btn btn-dark" @click="editUser(enrollee)">change</button> -->
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class=" col-md-6">
                                <div class="card m-b-30">
                                    <div class="card-header">
                                        <strong class="h4">Transactions</strong>
                                    </div>

                                    <div class="card-body">

                                        <div class="table-responsive">
                                            <table class="table align-td-middle table-card">
                                                <thead>
                                                    <tr>
                                                        <th>Amount</th>
                                                        <th>Enrollees</th>
                                                        <th>Date</th>
                                                        <th>Action</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="trx in transactions.data" v-bind:key="trx.id">
                                                        <td> <i class="mdi mdi-currency-ngn"></i> {{ trx.amount |
                                                            numeral("0,0") }} </td>
                                                        <td> <span v-if="trx.users.length > 0"> {{ trx.users.length
                                                                }}</span> </td>
                                                        <td>{{ trx.created_at | moment("dddd, MMMM Do YYYY") }}</td>
                                                        <td>
                                                            <a :href="`/payment/transaction/${trx.id}`"
                                                                class="btn btn-outline-info">
                                                                <i class="fe fe-eye"></i>

                                                            </a>
                                                        </td>


                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>


                        <!-- Modal -->
                        <div class="modal fade modal-slide-right" id="slideRightModalAll" tabindex="-1" role="dialog"
                            aria-labelledby="slideRightModalLabel" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content" id="printDiv" ref="printNow">
                                    <div class="modal-header">
                                        <p class="modal-title" id="slideRightModalLabel">
                                            <span class="h5">Payment Details</span>

                                        </p>

                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>

                                    <div class="modal-body">
                                        <div class="">
                                            <form @submit.prevent="addTransaction">
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label for="inputCity">Select Enrollees
                                                        </label>
                                                        <select class="form-control"
                                                            @change="getOrganizationClients(organization)"
                                                            v-model="transaction.enabled_user">

                                                            <option value=""> All</option>
                                                            <option value="1">Active</option>
                                                            <option :value="false">Inactive</option>
                                                            <option value="false">Selected</option>


                                                        </select>
                                                    </div>
                                                </div>



                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label for="inputCity">Select Plan
                                                            <span class="text-danger">*</span></label>
                                                        <select class="form-control" required
                                                            v-model="transaction.sector">
                                                            <option :value="plan.cost" v-for="plan in plans"
                                                                :key="plan.id">
                                                                {{ plan.title }}
                                                                -
                                                                {{ plan.cost | numeral(0, 0) }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>


                                                <div class="form-group col-md-12">
                                                    <label for="inputEmail4">Qty <span
                                                            class="text-danger">*</span></label>
                                                    <input type="number" class="form-control" required disabled
                                                        :value="organizationclients.meta.total" placeholder="Amount" />
                                                    <p class="text-sm"> total enrollees under the organization</p>
                                                </div>



                                                <div class="form-group col-md-12">
                                                    <label for="inputEmail4">Amount <span
                                                            class="text-danger">*</span></label>
                                                    <input type="number" class="form-control" required disabled
                                                        :value="transaction.sector * organizationclients.meta.total"
                                                        placeholder="Amount" />
                                                </div>


                                                <div class="form-group col-md-12">
                                                    <label for="inputEmail4">Date of Payment<span
                                                            class="text-danger">*</span></label>
                                                    <input type="date" class="form-control" required
                                                        :value="transaction.date" placeholder="Date" />
                                                </div>


                                                <div class="form-group col-md-12">
                                                    <label for="inputAddress">Description</label>
                                                    <textarea name="name" rows="3" cols="80" class="form-control"
                                                        v-model="transaction.description"></textarea>
                                                    <button type="submit" class="btn btn-info m-2 btn-block">
                                                        Submit
                                                    </button>
                                                </div>
                                            </form>

                                        </div>

                                        <div class="container">
                                            <div class="row">
                                                <div class="col-md-12 m-b-30">
                                                    <div class="card">
                                                        <div class="card-header border-bottom"></div>

                                                        <div class="card-footer row"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="modal-footer">

                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--End of Modal -->

                        <mda-certificate :organization-name="organization.name" :agency-name="agency.agency_name"
                            :agency-image="agency.user_image" :total-enrollees="organizationclients.meta.total"
                            @loading="isLoading = $event" />

                    </div>

                    <div class="vld-parent">
                        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage">
                        </loading>
                    </div>
                </section>
            </div>
        </main>
    </section>
</template>

<script>
    import Navbar from "@/views/Navbar.vue";
    import { randomAlphaNumeric } from "@/utils/secureRandom";
    import {
        buildSampleCsvText,
        parseCsvRows,
        mapCsvRowToPayload,
    } from "@/service/enrollee_csv_import";
    // Import component
    import Loading from "vue-loading-overlay";
    // Import stylesheet
    import "vue-loading-overlay/dist/vue-loading.css";
    import MDACertificate from "./component/MDACertificate.vue";
    // Init plugin
    let agency = JSON.parse(localStorage.getItem("agency"));

    export default {
        components: {
            Navbar,
            Loading,
            MdaCertificate: MDACertificate,
        },
        data() {
            return {
                agency: agency,
                user: null,
                types: ["online", "offline"],
                organization: "",
                transaction: {
                    "amount": 0,
                    "type": "offline",
                    "description": "",
                    "date": "",
                },
                transactions: [],
                organizationclients: {
                    meta: {
                        "total": 0,
                        "per_page": 0,
                        "current_page": 0,
                        "last_page": 0,
                        "from": 0,
                        "to": 0
                    },
                    data: []
                },
                plans: "",
                dashboarddata: "",
                edit: false,
                isLoading: false,
                fullPage: true,
                agency_id: "",
            };
        },
        beforeMount() {
            this.user = JSON.parse(localStorage.getItem("user"));
            this.axios
                .get(`/api/v1/auth/transactions`, {
                    params: {
                        agency_id: this.agency.id,
                        ministry_model_id: this.$route.params.id,
                    }
                })
                .then((response) => {
                    this.transactions = response.data;
                    console.log(response);
                })
                .catch((error) => {
                    console.error(error);
                });


        },
        methods: {

            getOrganization() {
                this.axios
                    .get(`/api/v1/auth/ministry/${this.$route.params.id}`)
                    .then((response) => {
                        this.organization = response.data.data;
                        this.getOrganizationClients(this.organization);
                        this.dashboardData(this.organization)
                        console.log(response);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },

            dashboardData(org) {
                this.axios
                    .get(`/api/v1/auth/ministry/stat/${this.agency.id}/${org.id}`)
                    .then((response) => {
                        this.dashboarddata = response.data;
                        console.log(response);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },
            getOrganizationClients(org) {

                this.isLoading = true;

                this.user = JSON.parse(localStorage.getItem("user"));
                this.axios
                    .get(`/api/v1/auth/getUsersfilterparams`, {
                        params: {
                            page: 1,
                            agency_id: agency.id,
                            perPage: 1000,
                            place_of_work: org.name,
                            enabled_user: this.transaction.enabled_user,
                        },
                    })
                    .then((response) => {
                        this.organizationclients = response.data;
                        this.isLoading = false;

                        console.log(response);
                    })
                    .catch((error) => {
                        console.error(error);
                        this.isLoading = false;
                    });
            },

            acceptorganization(status) {
                if (confirm("Are You Sure You Want to Update organization?")) {
                    this.user = JSON.parse(localStorage.getItem("user"));
                    this.isLoading = true;
                    this.axios
                        .post("/api/v1/auth/approveDisapproveorganizationByAgency", {
                            agency_id: this.agency.id,
                            organization_id: this.$route.params.id,
                            status: status,
                        })
                        .then((response) => {
                            console.log(response);
                            this.$breadstick.notify("organization Updated!", {
                                position: "top-right",
                            });
                            this.isLoading = false;
                            this.getorganization();
                            this.$router.push(`/mda-manager`);
                        })
                        .catch((error) => {
                            console.log(error.response);
                            this.isLoading = false;
                        });
                }
            },
            rejectorganization() {
                if (confirm("Are You Sure You Want to Disapprove this organization?")) {
                    this.user = JSON.parse(localStorage.getItem("user"));
                    this.isLoading = true;
                    this.axios
                        .post("/api/v1/auth/approveDisapproveorganizationByAgency", {
                            agency_id: this.agency.id,
                            organization_id: this.$route.params.id,
                            status: 0,
                        })
                        .then((response) => {
                            console.log(response);
                            this.$breadstick.notify("organization Disapproved!", {
                                position: "top-right",
                            });
                            this.isLoading = false;
                            this.getorganization();
                        })
                        .catch((error) => {
                            console.log(error.response);
                            this.isLoading = false;
                        });
                }
            },
            clearIt() {
                this.agency_id = "";
            },
            triggerCsvImport() {
                if (this.$refs.csvInput) {
                    this.$refs.csvInput.click();
                }
            },
            downloadSampleCsv() {
                const csvText = buildSampleCsvText();
                const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", "enrollee_import_sample.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);
            },
            onCsvFileSelected(event) {
                const file = event.target.files && event.target.files[0];
                if (!file) {
                    return;
                }

                const isCsv = file.type.includes("csv") || file.name.toLowerCase().endsWith(".csv");
                if (!isCsv) {
                    this.$toasted.error("Please select a CSV file", {
                        position: "top-center",
                        duration: 3000,
                    });
                    event.target.value = "";
                    return;
                }

                const reader = new FileReader();
                reader.onload = async (loadEvent) => {
                    const csvText = loadEvent.target && loadEvent.target.result ? String(loadEvent.target.result) : "";
                    await this.importUsersFromCsv(csvText);
                    event.target.value = "";
                };
                reader.onerror = () => {
                    this.$toasted.error("Unable to read CSV file", {
                        position: "top-center",
                        duration: 3000,
                    });
                    event.target.value = "";
                };
                reader.readAsText(file);
            },
            async importUsersFromCsv(csvText) {
                if (!this.organization || !this.organization.name) {
                    this.$toasted.error("Organization not loaded yet", {
                        position: "top-center",
                        duration: 3000,
                    });
                    return;
                }

                const rows = parseCsvRows(csvText);
                if (!rows.length) {
                    this.$toasted.error("CSV is empty", {
                        position: "top-center",
                        duration: 3000,
                    });
                    return;
                }

                this.isLoading = true;
                let successCount = 0;
                let failureCount = 0;

                for (let i = 0; i < rows.length; i++) {
                    const row = rows[i];
                    const payload = mapCsvRowToPayload(row, {
                        agencyId: this.agency.id,
                        enrolledBy: this.user ? this.user.id : 0,
                    });

                    if (!payload) {
                        failureCount++;
                        continue;
                    }

                    try {
                        await this.axios.post("/api/v1/auth/registerProvider", payload);
                        successCount++;
                    } catch (error) {
                        console.error(error);
                        failureCount++;
                    }
                }

                this.isLoading = false;

                if (successCount > 0) {
                    this.$toasted.success(`Imported ${successCount} enrollee(s)`, {
                        position: "top-center",
                        duration: 4000,
                    });
                    this.getOrganizationClients(this.organization);
                    this.dashboardData(this.organization);
                }

                if (failureCount > 0) {
                    this.$toasted.error(`${failureCount} row(s) failed to import`, {
                        position: "top-center",
                        duration: 4000,
                    });
                }
            },
            addTransaction() {
                this.isLoading = true;
                this.axios
                    .post(`/api/v1/auth/transactions`, {
                        agency_id: this.agency.id,
                        amount: this.transaction.sector * this.organizationclients.meta.total,
                        type: this.transaction.type,
                        date: this.transaction.date,
                        ministry_model_id: this.$route.params.id,
                        description: this.transaction.description,
                        transaction_ref: randomAlphaNumeric(20, '0123456789'),
                        status: "approved",
                        users: this.dashboarddata.ids,

                    })
                    .then((response) => {
                        console.log(response);
                        this.$toasted.success("Submitted Successfully", {
                            position: "top-center",
                            duration: 3000,
                        });
                        this.isLoading = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        this.$toasted.error("Error!", {
                            position: "top-center",
                            duration: 3000,
                        });
                        this.isLoading = false;
                    });
            },

            fetchPlans() {
                this.axios
                    .get(`/api/v1/auth/plans`, {
                        params: {
                            agency_id: this.agency.id,
                            perPage: 1000,
                        },
                    })
                    .then((response) => {
                        this.plans = response.data.data.data;
                        console.log(response);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },
        },
        created() {
            this.getOrganization();
            this.fetchPlans();
        },
    };
</script>
<style>
    .spacer {
        margin-left: 15px;
    }
</style>